import { render, staticRenderFns } from "./CouponEmptyState.vue?vue&type=template&id=76a2bd38&scoped=true&"
import script from "./CouponEmptyState.vue?vue&type=script&lang=js&"
export * from "./CouponEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./CouponEmptyState.vue?vue&type=style&index=0&id=76a2bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2bd38",
  null
  
)

export default component.exports